import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getArticlesEntrypoints } from '@dealstack/frontend/app/services/Blog.service.ts';
import { match } from 'path-to-regexp';
import { PageWithMatchers } from '@dealstack/frontend/shared/utils/pathMatchPage.ts';
import type { ClientPerspective } from '@sanity/client';
import { ApplicationType, EntrypointArticlesRes } from '@dealstack/shared/lib/generated';

export const useArticlesEntrypoints = (
	dataset: ApplicationType,
	language: string,
	perspective?: ClientPerspective
) => {
	const request = useQuery({
		queryKey: [
			API_PATHS.HELP_BLOG_DATASET_ARTICLES_ENTRYPOINTS_GET,
			{ dataset, language, perspective },
		],
		queryFn: () =>
			getArticlesEntrypoints(API_PATHS.HELP_BLOG_DATASET_ARTICLES_ENTRYPOINTS_GET, {
				dataset,
				language,
				perspective,
			}),
		select: (articlesEntrypoints): PageWithMatchers<EntrypointArticlesRes>[] => {
			if (!articlesEntrypoints) {
				return [];
			}

			return articlesEntrypoints.map((article) => ({
				...article,
				matchers: article.entrypoints.map((pattern) => match(pattern)),
			}));
		},
	});

	return {
		articlesEntrypoints: request.data || [],
	};
};
